import { DatePicker } from "@design-system/DatePicker/DatePicker";
import { VStack } from "@design-system/VStack/VStack";
import { getScheduleResumeDefaultDate } from "./scheduleResumeDate";

interface ScheduleResumeDateFieldProps {
    body: string;
    value: string;
    minDate?: string;
    onChange: (dateOnly: string) => void;
}

export const ScheduleResumeDateField = ({
    body,
    value,
    minDate,
    onChange,
}: ScheduleResumeDateFieldProps) => (
    <VStack gap={12}>
        <span>{body}</span>
        <DatePicker
            mode="day"
            variant="panel-input"
            clearable={false}
            value={value}
            minDate={minDate}
            onValueChange={(picked) =>
                onChange(picked ?? getScheduleResumeDefaultDate())
            }
        />
    </VStack>
);
